import React, { useState } from "react";
import style from './style.module.css';
import Checkbox from '../../components/Checkbox';
import { Row, Col } from 'react-bootstrap';
import IcArrow from "../Svg/IcArrow";

function Box(props) {
  const { permission, setpermissions, setAll } = props;

  const [opened, setopened] = useState(false);
  return (
    <Col sm={3}>
      <div data-opened={opened}>
        <span className={style.arrow} onClick={() => setopened(!opened)}><IcArrow direction={!opened ? "right" : "bottom"} /></span>
        <Checkbox
          className={style.checkbox}
          checked={!permission.options.some(__option => !__option.value)}
          semiChecked={permission.options.some(__option => !__option.value) && permission.options.some(__option => __option.value)}
          onChange={() => {
            let _value = false;
            if (permission.options.some(__option => !__option.value)) {
              _value = true
            }
            setAll(permission.group, _value)
          }}
        />
        <span>{permission.label}</span>
      </div>
      <ul className={style.options}>
        {permission.options.map(__option => (
          <li>
            <Checkbox
              className={style.checkbox}
              checked={__option.value || false}
              onChange={() => {
                setpermissions(permission.group, __option.action)
              }}
            />
            <span>{__option.label}</span>
          </li>
        ))}

      </ul>
    </Col>
  )
}

export default function Permissions(props) {

  const { permissions, setpermissions, setAll } = props;

  return (
    <Row>
      {permissions.map(__permission => (
        <Box
          permission={__permission}
          setpermissions={setpermissions}
          setAll={setAll}
        />
      ))}
    </Row>
    // <Row>

    //   <Box
    //     label="Calendário"
    //     options={["Leitura", "Criação", "Edição"]}
    //   />
    //   <Box
    //     label="Calendário"
    //     options={["Leitura", "Criação", "Edição"]}
    //   />
    //   <Box
    //     label="Calendário"
    //     options={["Leitura", "Criação", "Edição"]}
    //   />
    //   <Box
    //     label="Calendário"
    //     options={["Leitura", "Criação", "Edição"]}
    //   />
    // </Row>
  )
}